module.exports = __webpack_public_path__ + "static/media/badge-status-inactive.067986dc.svg";